<template>
  <div class="Man-PneuPrincipal">
    <PageTitle icon="fa fa-gear" main="Pneus" sub="Controle de pneus" />
    <div class="Man-PneuPrincipal">
      <b-card no-body>
        <b-tabs v-model="tabIndex">                                         
           <b-tab title="Lançamentos" active><PneuLancamento :tabTitle="tabIndex" /></b-tab>                                                                                                                        
           <b-tab title="Laudo"><PneuLaudo :tabTitle="tabIndex" /></b-tab>   
          <b-tab title="Recapadora"><PneuLancamento :tabTitle="tabIndex" /></b-tab>   
          <b-tab title="Venda   "><PneuLancamento :tabTitle="tabIndex" /></b-tab>   
          <!--           
          <b-tab title="Compra   "><PneuLancamento :tabTitle="tabIndex" /></b-tab>  
          -->
          <b-tab title="Compra" ><PneuCadastro /></b-tab>                  
          <b-tab title="KPI Estoque pneus" ><PneuPainelCadastro /></b-tab>                                                                 
          <!-- <b-tab title="KPI Movimentações pneus" ><PneuPainel /></b-tab>                                                                  -->
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import PneuLancamento from '../pneu/PneuLancamento'
import PneuCadastro from '../pneu/PneuCadastro'
import PneuLaudo from '../pneu/PneuLaudo'
import PneuPainelCadastro from '../pneu/PneuPainelCadastro'


export default {    
  name: 'PneuPrincipalLançamentos',    
  components: { PageTitle, PneuLancamento, PneuPainelCadastro,PneuCadastro,PneuLaudo },
  data() {
    return {
      tabIndex: 0
    };
  },    
  methods:{



  }
}
</script>

<style>
/* Estilos necessários */
</style>
